import React from 'react';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const MenuWrapper = styled('ul')`
  width: 100%;
  padding: 0;
  > li {
    display: flex;
    padding: 15px 22px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    color: #232323;
    border-left: 4px solid transparent;
    &:last-child {
      border-bottom: none;
    }
    &.active {
      color: #7e57c2;
      font-weight: 600;
      border-left: 4px solid #7e57c2;
    }
  }
`;

const PageMenu = (props) => {
  const { menuData = [], current, onSelect } = props;

  const { t } = useAutoTranslation();

  return (
    <MenuWrapper className="card-box">
      {menuData.map((m) => (
        <li
          key={m.id}
          className={`${current.id === m.id ? 'active' : ''}`}
          onClick={() => onSelect(m)}
        >
          {t(m.title)}
        </li>
      ))}
    </MenuWrapper>
  );
};

export default PageMenu;
